import React, { useContext } from 'react';
import './FooterTop.styles.scss';
// import IconMap from '../../../assets/Icons/icon-map.svg';
// import IconPhone from '../../../assets/Icons/icon-phone.svg';
import IconShield from '../../../assets/Icons/icon-shield.svg';
import LogoObjBranco from '../../../assets/Logo/logo-obj-branco.png';
import IconFB from '../../../assets/Icons/icon-social-ig.svg';
import IconYT from '../../../assets/Icons/icon-social-yt.svg';
import IconIG from '../../../assets/Icons/icon-social-fb.svg';
import { Link, useNavigate } from 'react-router-dom';
import { AccountContext } from '../../../contexts/AccountContext';

const FooterTop = () => {
	const { isLoggedIn, toggleAccountModal, termsContracts } =
		useContext(AccountContext);

	const navigate = useNavigate();
	const navigateConta = () => {
		navigate('/conta');
	};

	const accountModalHandler = () => {
		if (isLoggedIn === true) {
			navigateConta();
		} else {
			toggleAccountModal();
		}
	};

	return (
		<>
			<div className="footer-top-wrapper">
				<div className="footer-top-container">
					<div className="footer-logo-container">
						<div className="footer-logo-top-container">
							<div className="footer-logo">
								<img src={LogoObjBranco} alt="" />
							</div>
							<div className="footer-socials">
								<a href="https://www.facebook.com/colegioproposito" target='_blank' rel="noreferrer">
									<img src={IconFB} alt="" />
								</a>
								<a href="https://www.youtube.com/@colegioproposito" target='_blank' rel="noreferrer">
									<img src={IconYT} alt="" />
								</a>
								<a href="https://www.instagram.com/colegiopropositopi/" target='_blank' rel="noreferrer">
									<img src={IconIG} alt="" />
								</a>
							</div> 
						</div>
						<div className="footer-unidade-container">
							<div className="footer-unidade-row">
								<div className="footer-unidade">
									<h3>Unidade Leste</h3>
									<p>
										Rua Prof. Elías Tôrres, 137, <br/>
										São Cristovão.
									</p>
								</div>
								<div className="footer-unidade">
									<h3>Unidade Jockey</h3>
									<p>
										Rua das Orquídeas, 191, <br />
										Fátima.
									</p>
								</div>
								{/* <div className="footer-unidade">
									<h3>Unidade Leste Vestibulares</h3>
									<p>
										Rua das Orquídeas, 830 <br />
										(86) 3025-8551
									</p>
								</div> */}
							</div>
							<div className="footer-unidade-row">
								<div className="footer-unidade">
									<h3>Unidade Centro I</h3>
									<p>
										Rua Firmino Pires, 787, <br />
										Centro.
									</p>
								</div>
								<div className="footer-unidade">
									<h3>Unidade Centro II</h3>
									<p>
										Rua Rui Barbosa, 799, <br />
										Centro.
									</p>
								</div>
							</div>
						</div>
					</div>
					<div className="links-container">
						<h2 className="ul-title">Links Úteis</h2>
						<ul>
							<li style={{ cursor: 'pointer' }} onClick={accountModalHandler}>
								<h3>Minha Conta</h3>
							</li>
							<li>
								<Link to={'/compra-rapida'}>
									<h3>Compra Rápida</h3>
								</Link>
							</li>
							<li>
								<Link to={'/faq'}>
									<h3>F.A.Q.</h3>
								</Link>
							</li>
							<li>
								<Link to={'/atendimento'}>
									<h3>Atendimento</h3>
								</Link>
							</li>
							<li>
								<a
									target="_blank"
									rel="noopener noreferrer"
									href={termsContracts}>
									<h3>Termos & Condições</h3>
								</a>
							</li>


						</ul>
						<div className="segurança-container">
							<img src={IconShield} alt="secure" />
							<div className="segurança-text">
								<h3>100% Seguro</h3>
								<p>Suas informações estão criptografadas e seguras.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default FooterTop;